import { getClientByDocument } from '#services/client.js';
import { getStockByStore } from '#services/stock.js';
import { useEffect, useState } from 'react';
import { getNoveltyByDate } from '#services/novelty.js';
import { dateNow } from '#utils/date.js';
import { useRegisterStock } from '#hooks/useRegisterStock.js';
import { formatNumber } from '#helpers/formatNumbers.js';

const Stock = ({ isAuth, user }) => {
  const [stockProducts, setStockProducts] = useState(null);
  const [error, setError] = useState({});
  const { handleRegister, setShowStock, showStock } = useRegisterStock();

  const handleSubmit = async (e) => {
    e.preventDefault();

    showHideLoad(true);

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    if (data?.Novedad.length === 0) return setError({ novelty: 'Campo vacío' });

    try {
      await handleRegister({ data, status: 'Observacion' });

      hideModalStock();
      showHideLoad(false);
    } catch (error) {
      console.log('No se pudo registrar la novedad' + error.message);
    }
  };

  const handleAcceptStock = async () => {
    showHideLoad(true);
    try {
      await handleRegister({ status: 'Aceptado' });
      hideModalStock();
      showHideLoad(false);
    } catch (error) {
      console.log('No se pudo aceptar el inventario: ' + error.message);
    }
  };

  const showHideLoad = (showLoad) => {
    const load = document.querySelector('.load-stock .loader');
    const check = document.querySelector('.check-stock');
    if (showLoad) {
      load.classList.add('show');
    } else {
      load.classList.remove('show');
      check.classList.add('show');
    }
  };

  const validateNovelty = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '');
      if (!user?.document_number) return;

      const novelty = await getNoveltyByDate(dateNow(), user.document_number);
      if (!novelty) setShowStock(true);
    } catch (error) {
      console.log('Error al validar el inventario');
    }
  };

  const getStock = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '');

      if (!user?.document_number) return;

      const client = await getClientByDocument(user.document_number);

      //Almacenar el ID de las bodegas en caso de tener una o varias
      const storesIds =
        client?.Bodegas.length > 0
          ? client.Bodegas.map((bodega) => bodega.ID)
          : client.Bodega?.ID || null;

      const stock = await getStockByStore(storesIds);

      if (stock && stock.length === 0) return;

      setStockProducts(stock);
    } catch (error) {
      console.log(`Error al traer el inventario`);
    }
  };

  const hideModalStock = () => {
    const modalStock = document.querySelector('.modal');
    modalStock.classList.remove('show-modal');
  };

  useEffect(() => {
    getStock();
    validateNovelty();
  }, []);

  return (
    isAuth && (
      <div className="modal">
        <section className="stock">
          <div className="container">
            <div className="row">
              <div className="col col-100">
                <h2 className="title">Inventario</h2>
              </div>
            </div>
            <div className="row my">
              <div className="col col-50 col-100-sm-mb">
                <button
                  className={`btn btn-blue ${!showStock && 'disabled'}`}
                  onClick={() => handleAcceptStock()}
                  disabled={!showStock}
                >
                  Aceptar inventario
                </button>
              </div>
              <div className="col col-50 col-100-sm-mb mt-mb">
                <form onSubmit={handleSubmit} className="form-nolvelty">
                  <div className="block-input">
                    <input
                      type="text"
                      className="input-novelty"
                      placeholder="Agregar observación"
                      name="Novedad"
                    />
                    <span className="text-error span-block">
                      {error?.novelty || ''}
                    </span>
                  </div>
                  <button
                    type="submit"
                    className={`btn btn-blue ${!showStock && 'disabled'}`}
                    disabled={!showStock}
                  >
                    Enviar
                  </button>
                </form>
              </div>
            </div>
            <div className="row center-block">
              <div className="col col-33">
                <div className="load load-stock">
                  <div className="loader"></div>
                  <i className="fa-solid fa-check check-stock"></i>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col col-100">
                {stockProducts ? (
                  <table>
                    <thead>
                      <th>Producto</th>
                      <th>Cantidad</th>
                      <th>Bodega</th>
                      {user?.userType === 'Aliado' ? (
                        <th>Precio Aliado</th>
                      ) : user?.userType === 'Mayorista' ? (
                        <th>Precio Mayorista</th>
                      ) : (
                        ''
                      )}
                      <th>Precio Sugerido</th>
                    </thead>
                    <tbody>
                      {stockProducts &&
                        stockProducts.map((product) => (
                          <tr key={product.ID}>
                            <td>{product['Productos.Referencia']}</td>
                            <td>{product.Cantidad}</td>
                            <td>{product.Bodega.Nombre}</td>
                            {user?.userType === 'Aliado' ? (
                              <td>
                                $
                                {formatNumber(
                                  product['Productos.Precio_Aliado'],
                                )}
                              </td>
                            ) : user?.userType === 'Mayorista' ? (
                              <td>
                                $
                                {formatNumber(
                                  product['Productos.Precio_Mayorista'],
                                )}
                              </td>
                            ) : (
                              ''
                            )}

                            <td>
                              ${formatNumber(product['Productos.Precio_detal'])}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <span className="center-block">
                    No hay productos disponibles en inventario
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="btn-close" onClick={() => hideModalStock()}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </section>
      </div>
    )
  );
};

export default Stock;
